import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import type { DictPhoneme, DictGrapheme } from '@/features/dictionary/api/types'

export interface CefrLevel {
  id: number;
  code: string;
  name: string;
}

interface MetadataState {
  voices: string[] | null;
  levels: CefrLevel[] | null;
  dictPhonemes: DictPhoneme[] | null;
  dictGraphemes: DictGrapheme[] | null;
}

const initialState: MetadataState = {
  voices: null,
  levels: null,
  dictPhonemes: null,
  dictGraphemes: null,
}

export const metadataSlice = createSlice({
  name: 'metadata',
  initialState,
  reducers: {
    setVoices: (state, action: PayloadAction<string[]>) => {
      state.voices = action.payload
    },
    setLevels: (state, action: PayloadAction<CefrLevel[]>) => {
      state.levels = action.payload
    },
    setDictPhonemes: (state, action: PayloadAction<DictPhoneme[]>) => {
      state.dictPhonemes = action.payload
    },
    setDictGraphemes: (state, action: PayloadAction<DictGrapheme[]>) => {
      state.dictGraphemes = action.payload
    },
  },
})

export const { setVoices, setLevels, setDictPhonemes, setDictGraphemes } = metadataSlice.actions
export default metadataSlice.reducer
